import React from "react"
import Img from "gatsby-image"
import { Link } from "gatsby"
import { workCard, text, gatsbyImage } from "./work.module.scss"

const WorkCard = ({ work }) => {
  const { title, slug, gallery } = work
  const firstImage = gallery[0].localFile.childImageSharp["fluid"]

  return (
    <Link to={`/work/${slug}`} className={workCard}>
      <article>
        <Img fluid={firstImage} className={gatsbyImage} />
        <div className={text}>
          <h4>{title}</h4>
        </div>
      </article>
    </Link>
  )
}

export default WorkCard
